import { gql } from "@apollo/client";

export const CREATE_LOG_MUTATION = gql`
  mutation createLog($create_log_input: CreateLogInput) {
    createLog(create_log_input: $create_log_input)
  }
`;
